module.exports = __webpack_public_path__ + "05_glasses_black.a32760e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/05_glasses_black.png
// module id = Nzhc
// module chunks = 0